import { useSyncExternalStore } from 'react';

let count = 0;
const listeners = new Set();

export const getUnread = () => count;

export const setUnread = (n) => {
  count = Math.max(0, n || 0);
  listeners.forEach((l) => l());
};

const subscribe = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const useUnreadCount = () => useSyncExternalStore(subscribe, getUnread);
